import '../environment/crypto/index.js';
import 'dayjs';
import '@caresend/types';
import 'immutability-helper';
import 'lodash-unified';
import { objToKeyValueArray, objectSome } from '../languageExtensions/object.js';
import '../formatters/string.js';
import 'ngeohash';
import '../formatters/location.js';
import { initProcedureInstruction } from '../initializers/procedure.js';
import '../initializers/user.js';

/**
 * Get the instruction that is present,
 * without generating a new one if it is missing.
 */

const getRawInstruction = (instructions, instructionType) => instructions === null || instructions === void 0 ? void 0 : instructions.find(item => item.type === instructionType);
/**
 * Get the instruction that is present.
 * Generates a new one if it is missing.
 */

const getInstruction = (instructions, instructionType) => {
  var _a;

  return (_a = getRawInstruction(instructions, instructionType)) !== null && _a !== void 0 ? _a : initProcedureInstruction(instructionType);
};
const getProcessing = supplyInstruction => {
  const supplyInstructions = supplyInstruction.instructions;
  const sampleProcessing = supplyInstruction.processing;
  if (supplyInstructions) return supplyInstructions;
  if (sampleProcessing) return [sampleProcessing];
  return [];
};
/**
 * Check if supplyInstruction contain a certain type of SupplyInstructionOptions
 */

const hasTypeOfSupplyInstructionSingleCheck = (supplyInstruction, type) => {
  if (!supplyInstruction) return false;
  const processing = getProcessing(supplyInstruction);
  return processing.some(instructions => {
    const instructionsKeyVal = objToKeyValueArray(instructions);
    return instructionsKeyVal.some(({
      key: instructionType,
      value: hasInstruction
    }) => instructionType === type && hasInstruction);
  });
};
/**
 * Check if supplyInstructions contain a certain type of SupplyInstructionOptions
 */

const hasTypeOfSupplyInstruction = (supplyInstructions, type) => objectSome(supplyInstructions !== null && supplyInstructions !== void 0 ? supplyInstructions : {}, item => hasTypeOfSupplyInstructionSingleCheck(item, type));

export { getInstruction, getProcessing, getRawInstruction, hasTypeOfSupplyInstruction, hasTypeOfSupplyInstructionSingleCheck };
